module.exports = __webpack_public_path__ + "static/media/nasa-icon-png-7.c51d00ea.png";